import o from "react";
import { cls as i } from "../../helpers/cls.js";
var c = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  p = Object.prototype.hasOwnProperty,
  d = Object.prototype.propertyIsEnumerable,
  l = (e, r, a) => r in e ? c(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  s = (e, r) => {
    for (var a in r || (r = {})) p.call(r, a) && l(e, a, r[a]);
    if (t) for (var a of t(r)) d.call(r, a) && l(e, a, r[a]);
    return e;
  };
const m = e => o.createElement("span", s({
  "data-ds-component": "DS-VisuallyHidden",
  className: i("olx-visually-hidden", e.className)
}, e), e.children);
export { m as VisuallyHidden };